export default __webpack_public_path__ + "static/media/sign-up-banner.4a3caa67.png";